export type TCountryId = number;

export interface Country {
  id: TCountryId;
  name: string;
  short_code: string;
  currency_code: string;
}
